interface TitleProps {
  name?: string;
  role?: string;
  className?: string;
}

export const Title: React.FC<TitleProps> = ({
  name = 'Amandine Quellec',
  role = 'Creative Technologist',
  className = '',
}) => {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <h1 className="text-xl md:text-2xl font-medium text-black leading-tight">{name}</h1>
      <h2 className="text-sm md:text-base text-black/55 tracking-wide">{role}</h2>
    </div>
  );
};
